'use client';
import React from 'react';
import { Text, Anchor } from '@mantine/core';
import useSafeTranslation from '@/hooks/useSafeTranslation';

export function Footer() {
  const { tSafe: t } = useSafeTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Text size="sm">
        {t('footer.developedBy')}{' '}
        <Anchor href="https://yulistoyanov.com" target="_blank" rel="noopener noreferrer" size="sm">
          Yuliyan Stoyanov
        </Anchor>{' '}
        © {currentYear} {t('appTitle')}
      </Text>
    </footer>
  );
}
